// extracted by mini-css-extract-plugin
module.exports = {"negative":"Balance_negative__fpICh","positive":"Balance_positive__35VCJ","avg":"Balance_avg__zxFyG"};